import { Component, Input, Output, EventEmitter } from '@angular/core';
import { DropdownItem, DropdownList } from '@src/core/domain/business-models/dropdown.model';

@Component({
  selector: 'bfd-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss']
})
export class DropdownComponent {
  @Input() buttonLabel: string = 'Selecionar';
  @Input() items: { name: string; value: any }[] = [];
  @Input() public options: DropdownList;
  @Input() public placeholder: string;
  @Output() select = new EventEmitter<any>();
  @Output() public selected?: EventEmitter<any> = new EventEmitter();
  @Output() public change: EventEmitter<any> = new EventEmitter();
  @Output() public emitChange: EventEmitter<any> = new EventEmitter();
  @Output() public callback?: EventEmitter<number> = new EventEmitter();
  
  public hasOpened: boolean = false;


  ngOnInit(){
    console.log(this.items)
  }

  toggleDropdown() {
    this.hasOpened = !this.hasOpened;
  }

  onSelect(item: any) {
    this.select.emit(item);
    this.hasOpened = false;
  }


}
